export const STATUS = {
  PENDING    : 'pending',
  PROCESSING : 'processing',
  COMPLETED  : 'completed',
  REJECTED   : 'rejected',
  VOID       : 'void'
}

export const IS_ORDER_CANCELABLE_OPTIONS = {
  YES : true,
  NO  : false
}

export const IS_CANCELABLE_VALUES = [
  {
    label : 'All',
    value : ''
  },
  ...Object.keys(IS_ORDER_CANCELABLE_OPTIONS).map((key) => (
    {
      label : key,
      value : IS_ORDER_CANCELABLE_OPTIONS[key]
    }
  ))
]

export const STATUS_VALUES = [
  {
    label : 'All',
    value : ''
  },
  ...Object.keys(STATUS).map((key) => (
    {
      label : key,
      value : STATUS[key]
    }
  ))
]

export const CUSTOMER_BANK_NAME = {
  BCA     : 'BCA',
  MANDIRI : 'MANDIRI',
  BNI     : 'BNI',
  OTHERS  : 'OTHERS'
}

export const TL_BANK = {
  1 : 'BCA 5244 999 270 a/n Momentum Global Pratama',
  2 : 'MANDIRI 1240 0220 005 004 a/n Momentum Global Pratama',
  3 : 'BNI 2019 033 000 a/n Momentum Global Pratama'
}
